import { types } from "mobx-state-tree";

import { MenuItems } from "../../components/secondary-menu/SecondaryMenu";
import {
  AddUserToOrganization,
  EditUser,
  ManageSubscriptions,
  ViewUser,
} from "../../services/authorization/Permissions";
import { permissionsService } from "../../services/authorization/UserPermissionsService";

export enum UserDynamicMenuItemsPages {
  EditUser,
}

export const UserMenuItemsModel = types
  .model({
    userId: types.optional(types.number, 0),
    isLoading: false,
    editMode: types.optional(types.boolean, false),
    createMode: types.optional(types.boolean, false),
    dynamicMenuItemPage: types.maybe(types.frozen<UserDynamicMenuItemsPages>()),
    organizationHasStripeCustomer: types.optional(types.boolean, false),
  })
  .actions((self) => {
    return {
      getStaticItems(): MenuItems {
        const details = {
          "general.general": {
            items: [
              {
                id: "secondary-menu-users-details",
                labelKey: "general.users.details",
                path: getUserDetailsPath(),
                canAccess: canAccessUserDetailsPage(),
                disabled: self.isLoading,
                isActive: self.dynamicMenuItemPage === UserDynamicMenuItemsPages.EditUser,
              },
            ],
            defaultOpen: true,
          },
        };
        const usage = {
          "general.subscription-usage": {
            items: [
              {
                id: "secondary-menu-users-usage",
                labelKey: "general.users.usage",
                path: `/${self.userId}/va-usage`,
                canAccess: canAccessUsagePage(),
                disabled: self.isLoading,
              },
            ],
            defaultOpen: true,
          },
        };
        return self.createMode ? details : { ...details, ...usage };
      },
    };

    function getUserDetailsPath(): string {
      if (self.createMode) return "/invite-user";
      return `/${self.userId}`;
    }

    function canAccessUserDetailsPage(): boolean {
      if (self.createMode) return permissionsService.userHasPermissionTo(AddUserToOrganization);
      if (self.editMode) return permissionsService.userHasPermissionTo(EditUser);
      return permissionsService.userHasPermissionTo(ViewUser);
    }

    function canAccessUsagePage(): boolean {
      return (
        self.organizationHasStripeCustomer &&
        permissionsService.userHasPermissionTo(ManageSubscriptions)
      );
    }
  });
